import { Pipe, PipeTransform } from '@angular/core';
import { ExecutionDetail } from '@classes/workflow/execution-detail';

@Pipe({
    name: 'time'
})
export class ToTimePipe implements PipeTransform {

    transform(value: ExecutionDetail[] | ExecutionDetail): any {
        let time = 0;

        if (value == null) {
            return '';
        }

        if (Array.isArray(value)) {
            if (value.length === 0) {
                return '';
            }

            value.forEach((v: ExecutionDetail) => {
                if (v.duration) {
                    time += v.duration;
                }
            });
        } else {
            if (value.duration) {
                time = value.duration;
            }
        }

        const milliseconds = Math.floor(time % 1000).toString().padStart(3, '0');
        const seconds = Math.floor((time / 1000) % 60).toString().padStart(2, '0');
        const minutes = Math.floor((time / 1000 / 60) % 60).toString().padStart(2, '0');
        const hours = Math.floor(time / 1000 / 3600).toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}.${milliseconds}`;
    }

}
